/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Releasedate_Releasedonpc4Inputs */

const id_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirilis di PC`)
};

const ms_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikeluarkan di PC`)
};

const da_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivet på PC`)
};

const de_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht auf PC`)
};

const en_us2_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released on PC`)
};

const es_es2_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzado en PC`)
};

const es_mx2_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzado en PC`)
};

const fil_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inilabas sa PC`)
};

const fr_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorti sur PC`)
};

const it_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uscito su PC`)
};

const hu_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelent PC-n`)
};

const nl_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgebracht op pc`)
};

const no_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgitt på PC`)
};

const pl_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydane na PC`)
};

const pt_br2_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançado no PC`)
};

const pt_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançado no PC`)
};

const ro_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansat pe PC`)
};

const fi_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaistu PC:lle`)
};

const sv_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Släppt på PC`)
};

const vi_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phát hành trên PC`)
};

const tr_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC'de yayınlandı`)
};

const cs_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vydáno na PC`)
};

const bg_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издадено на PC`)
};

const ru_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вышло на ПК`)
};

const uk_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Випущено на ПК`)
};

const ar_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صدر على PC`)
};

const hi_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC पर रिलीज़ हुआ`)
};

const th_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วางจำหน่ายบน PC`)
};

const ja_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC版リリース`)
};

const zh_cn2_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC发布日期`)
};

const zh_hant1_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC發布日期`)
};

const ko_offerdetail_releasedate_releasedonpc4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedonpc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC 출시`)
};

/**
* | output |
* | --- |
* | "Released on PC" |
*
* @param {Offerdetail_Releasedate_Releasedonpc4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_releasedate_releasedonpc4 = /** @type {((inputs?: Offerdetail_Releasedate_Releasedonpc4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Releasedate_Releasedonpc4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "ms") return ms_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "da") return da_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "de") return de_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "en-US") return en_us2_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "fil") return fil_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "fr") return fr_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "it") return it_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "hu") return hu_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "nl") return nl_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "no") return no_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "pl") return pl_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "pt") return pt_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "ro") return ro_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "fi") return fi_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "sv") return sv_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "vi") return vi_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "tr") return tr_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "cs") return cs_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "bg") return bg_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "ru") return ru_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "uk") return uk_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "ar") return ar_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "hi") return hi_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "th") return th_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "ja") return ja_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_releasedate_releasedonpc4(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_releasedate_releasedonpc4(inputs)
	return ko_offerdetail_releasedate_releasedonpc4(inputs)
});
export { offerdetail_releasedate_releasedonpc4 as "offerDetail.releaseDate.releasedOnPc" }